<h1>Approve Member Purchases</h1>
<nav mat-tab-nav-bar [tabPanel]="tabs">
  @for (link of links; track link) {
    <a mat-tab-link [routerLink]="link.link"
      (click)="activeLink = link"
    [active]="activeLink == link">{{link.title}}</a>
  }
</nav>
@if (activeLink?.title === 'Transactions') {
  <app-analytics-toapprove></app-analytics-toapprove>
}
@if (activeLink?.title === 'Receipts to Approve') {
  <app-analytics-approve [filter]="''" [activeTitle]="activeLink?.title || ''"></app-analytics-approve>
}
@if (activeLink?.title === 'Approved Receipts') {
  <app-analytics-approve [filter]="'Reimbursement approved'" [activeTitle]="activeLink?.title || ''"></app-analytics-approve>
}
@if (activeLink?.title === 'Denied Receipts') {
  <app-analytics-approve [filter]="'Reimbursement denied'" [activeTitle]="activeLink?.title || ''"></app-analytics-approve>
}
@if (activeLink?.title === 'Reimbursements') {
  <app-analytics-approve [filter]="'Reimbursed'" [activeTitle]="activeLink?.title || ''"></app-analytics-approve>
}
@if (activeLink?.title === 'Configure Approvers') {
  <app-analytics-configure></app-analytics-configure>
}
<mat-tab-nav-panel #tabs></mat-tab-nav-panel>
